export class AppSettings {

    public tiServicesHost =  import.meta.env.VITE_TI_SERVICES_HOST;
    public tiApiVersion =  import.meta.env.VITE_TI_API_VERSION;
    public tiMarketDataThrottleMs =  import.meta.env.VITE_MARKET_DATA_THROTTLE_MS;
    
    private static instance: AppSettings | null = null;

    public static getInstance(): AppSettings {
        if (!this.instance) {
            this.instance = new AppSettings();
        }

        return this.instance;
    }
}